// Compact G+ brand mark — italic Chalk G on Ink field with Butter + superscript.
// Sizes: pass "sm" (28), "md" (36), "lg" (48), "xl" (72) or a custom number of px.

const SIZE_MAP = { sm: 28, md: 36, lg: 48, xl: 72 };

export default function GMark({ size = "md", className = "", title = "Gate + Gather", ...rest }) {
  const px = typeof size === "number" ? size : SIZE_MAP[size] || SIZE_MAP.md;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 128 128"
      width={px}
      height={px}
      role="img"
      aria-label={title}
      className={className}
      data-testid="g-plus-mark"
      {...rest}
    >
      <title>{title}</title>
      <rect width="128" height="128" rx="22" fill="#20251F" />
      <text
        x="26"
        y="94"
        fontFamily="Georgia, 'Times New Roman', serif"
        fontSize="92"
        fontWeight="500"
        fontStyle="italic"
        fill="#FFFCF6"
        letterSpacing="-2"
      >
        G
      </text>
      <text
        x="102"
        y="46"
        textAnchor="middle"
        fontFamily="Georgia, 'Times New Roman', serif"
        fontSize="40"
        fontWeight="600"
        fill="#B7D33F"
      >
        +
      </text>
    </svg>
  );
}
